export default (entity = {}) => {
    return {
        fullAddress: entity.fullAddress || '',
        city: entity.city || '',
        street: entity.street || '',
        streetNumber: entity.streetNumber || '',
        entrance: entity.entrance || '',
        floor: entity.floor || '',
        apartment: entity.apartment || '',
        remarks: entity.floor || '',
    };
};
